module.exports = __webpack_public_path__ + "static/media/ibituruna.dd232b48.png";